import React from "react";

// Subtle iPhone-style frame wrapper with restrained emerald glow.
const DeviceFrame = ({ src, alt, className = "" }) => (
  <div className={`relative ${className}`}>
    <div className="absolute -inset-6 bg-[#10C98A]/10 blur-3xl rounded-[3rem] -z-10" />
    <div className="relative rounded-[2.4rem] border border-[#29354A] bg-[#0A1220] p-2 device-glow">
      <div className="rounded-[2rem] overflow-hidden border border-black/40">
        <img src={src} alt={alt} className="w-full block" loading="lazy" draggable={false} />
      </div>
    </div>
  </div>
);

export default DeviceFrame;
